import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor implements HttpInterceptor {
  constructor(private message: NzMessageService, private router: Router) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = sessionStorage.getItem('token');
    if (token) {
      const clonedRequest = req.clone({
        setHeaders: {
          token: token,
        },
      });
      // 使用克隆的请求
      return next.handle(clonedRequest).pipe(
        catchError((error: HttpErrorResponse) => {
          // 处理请求错误
          console.error('An error occurred:', error.error);
          // 可以在此处添加更多的错误处理逻辑
          //401错误时，跳转到登录页面并刷新
          if (error.status === 401 || error.status === 403) {
            this.message.error('登录凭证失效，请重新登录');
            this.router.navigate(['/login']);
          }
          // 重新抛出错误
          return throwError(error);
        })
      );
    } else {
      // 如果没有 token，则继续发送原始请求
      return next.handle(req).pipe(
        catchError((error: HttpErrorResponse) => {
          // 处理请求错误
          console.error('An error occurred:', error.error);
          // 可以在此处添加更多的错误处理逻辑
          //401错误时，跳转到登录页面并刷新
          if (error.status === 401 || error.status === 403) {
            this.message.error('登录凭证失效，请重新登录');
            this.router.navigate(['/login']);
          }
          // 重新抛出错误
          return throwError(error);
        })
      );
    }
  }
}
